<script>
    import { onMount } from 'svelte';
    import { user, userProfile, signIn, signOut } from "../store/auth.js";
    import { Navigate, Route, navigateTo, routeIsActive } from "svelte-router-spa";
    import Searchbar from "./Searchbar.svelte";
    import UserProfile from "./UserProfile.svelte"
    import { theRoute } from "../store/shared.js";

    var activeItem = 'langs'

    onMount(async () => {
        theRoute.subscribe(route => {
            var splitted = route.path.split('/')
            if (splitted && splitted.length >= 2) {
                activeItem = splitted[2]
            }
        }
        )
    });

    function goTo(routeName) {
        try {
            var splitted = routeName.split('/')
            if (splitted && splitted.length >= 2) {
                activeItem = splitted[2]
            }
            navigateTo(routeName)

        } catch (error) {

        }
    }



</script>
<nav class="navbar navbar-expand-lg" id="navbar">
    <div class="container">
        <a class="navbar-brand">
            <div>
                <img src="/images/tamseel_logo.png" alt="Logo" style="width: 32px;">
            </div>
        </a>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon" style="color: red;"></span>
        </button>

        <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <!-- <Searchbar /> -->
            <ul class="navbar-nav mr-auto">
                {#if $userProfile &&  $userProfile.role == 'admin'}
                    <li class="nav-item active">
                        <button on:click="{() => goTo('/admin/langs')}" type="button"
                            class:activeNav="{activeItem == 'langs'}" class:btn="{true}" class:btn-light="{true}"
                            class:nav-btn="{true}" class:nav-btn-left="{true}">Languages</button>
                    </li>
                    <li class="nav-item">
                        <button on:click="{() => goTo('/admin/users')}" type="button"
                            class:activeNav="{activeItem == 'users'}" class:btn="{true}" class:btn-light="{true}"
                            class:nav-btn="{true}">Users</button>
                    </li>
                    <li class="nav-item">
                        <button on:click="{() => goTo('/admin/in-app-ads')}" type="button"
                            class:activeNav="{activeItem == 'in-app-ads'}" class:btn="{true}" class:btn-light="{true}"
                            class:nav-btn="{true}">In-App Ads</button>
                    </li>
                    <li class="nav-item">
                        <button on:click="{() => goTo('/admin/settings')}" type="button"
                            class:activeNav="{activeItem == 'settings'}" class:btn="{true}" class:btn-light="{true}"
                            class:nav-btn="{true}">Settings</button>
                    </li>
                {/if}
                <li class="nav-item">
                    <button on:click="{() => goTo('/admin/translations')}" type="button"
                        class:activeNav="{activeItem == 'translations'}" class:btn="{true}" class:btn-light="{true}"
                        class:nav-btn="{true}" class:nav-btn-left="{$userProfile &&  $userProfile.role == 'manager'}" >Translation</button>
                </li>
            </ul>
            <UserProfile />
        </div>
    </div>
</nav>

<style>
    .activeNav {
        background-color: #f50 !important;
        color: white !important;
    }
</style>